export default "__VITE_ASSET__c328629e__"